import { MIN_IN_MS } from '@/base/MaUtils'
import { maLogger } from './logger'

// prefix everything with this to separate our requests
const REQUEST_POOL_PREFIX = 'MA_REQUEST_POOL_'
// expired clean timeout time in ms
let expiredCleanTimeout = 0

// helper private functions
const getRequestKey = key => `${REQUEST_POOL_PREFIX}${key}`

// storage wrappers for request

function clearExpired() {
  try {
    if (expiredCleanTimeout > Date.now()) {
      return
    }
    expiredCleanTimeout = Date.now() + 5 * MIN_IN_MS
    Object.keys(sessionStorage)
    // filter request caches
      .filter(k => k.startsWith(REQUEST_POOL_PREFIX))
    // get parsed values
      .map(key => ({ key, value: sessionStorage.getItem(key) }))
    // filter out invalid requests
      .filter(kv => !kv.value || !kv.value.exp || kv.value.exp < Date.now())
    // remove them
      .forEach(({ key }) => {
        maLogger.info('Removing expired request cache:', key)
        sessionStorage.removeItem(key)
      })
  }
  catch (e) {
    maLogger.warn('Failed to clear expired session storage items', e)
  }
}

export function get(url) {
  clearExpired()
  const cachedResponse = sessionStorage.getItem(getRequestKey(url))
  // if it has a valid expiration time and not expired yet return it
  if (cachedResponse && cachedResponse.exp && cachedResponse.exp > Date.now()) {
    maLogger.info(`Using cached data(ts=${cachedResponse.ts}) for: ${url}`)
    return cachedResponse.data
  }
  sessionStorage.removeItem(getRequestKey(url))
  return null
}

export function set(url, data, cacheTimeout = 60 * MIN_IN_MS) {
  clearExpired()
  const ts = Date.now()
  const exp = ts + cacheTimeout
  maLogger.info(`Caching data at ${ts} until ${exp} for: ${url}`)
  return sessionStorage.setItem(getRequestKey(url), {
    data,
    ts,
    exp,
  })
}

export function del(url) {
  clearExpired()
  sessionStorage.removeItem(getRequestKey(url))
}
